import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';

const AddThemeModal = ({ onAddTheme, onClose }) => {
  const [themeName, setThemeName] = useState('');
  const [empty, setEmpty] = useState(false)

  const inputRef = useRef(null)


  const handleAddTheme = () => {
    if (themeName.trim() !== '') {
      setEmpty(false)

      onAddTheme(themeName);
      setThemeName('');
    } else {
      setEmpty(true)
    }
  };


  useEffect(()=> {
    if(inputRef.current) {
      inputRef.current.focus()
    }
  }, [])


  const handleKeyDown = (e) => {
    if(e.key === 'Enter' && themeName !== '') {
      handleAddTheme()
    }
  }

  return (
    <ModalContainer>
      <ModalContent>
        <CloseButton onClick={onClose} style={{fontSize: 'large'}}><CloseIcon /></CloseButton>
        <h2>Add Theme</h2>
        <input type="text" value={themeName} onChange={(e) => setThemeName(e.target.value)} ref={inputRef} onKeyDown={handleKeyDown} style={empty? {borderColor: 'red'}: {}}/>
        <Button onClick={handleAddTheme}>Add Theme</Button>
      </ModalContent>
    </ModalContainer>
  );
};

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  position: relative;
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);

  > input {
    height: 25px;
    padding-inline: 5px;
    font-size: medium;
    outline: none;
    font-family: 'Crimson Text';
  }

  > h2 {
    font-weight: 300;
    margin-bottom: 25px;
  }
`;

const Button = styled.button`
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
  margin-left: 30px;

  &:hover {
    background-color: #0056b3;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 4px;
  background-color: transparent;
  color: #000;
  border: none;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    color: red;
  }
`;

export default AddThemeModal;
